// frontend/src/hooks/livestockPhotoKeys.ts
/**
 * React Query keys for organisms' photos as the compare page reads them
 * (docs/plans/2026-10-29-livestock-compare-plan.md, 5.1). Invalidating
 * `all(tankId, livestockId)` refreshes one organism's index and single photos;
 * `tank(tankId)` every organism's in the tank. Never persisted (signed URLs).
 */
export const livestockPhotoKeys = {
  tank: (tankId: string) => ['livestock-photos', tankId] as const,
  all: (tankId: string, livestockId: number) => ['livestock-photos', tankId, livestockId] as const,
  index: (tankId: string, livestockId: number) =>
    ['livestock-photos', tankId, livestockId, 'index'] as const,
  one: (tankId: string, livestockId: number, id: number) =>
    ['livestock-photos', tankId, livestockId, 'one', id] as const,
};

/** The organism's detail read (`useLivestockDetail`'s key, useLivestock.ts). */
export function livestockDetailKey(
  tankId: string | undefined,
  livestockId: number | null | undefined
): readonly ['livestock-detail', string | undefined, number | null | undefined] {
  return ['livestock-detail', tankId, livestockId] as const;
}
